import { EnumTipoDomandaDTOStato } from '@framework/api-client/api/inquiries/schemas/enumTipoDomandaDTOStato.ts';
import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';

/**
 * Anteprima in sola lettura: attiva solo per le domande pubblicate
 * ma non ancora attive e non scadute (stato PUBBLICATA).
 * Dalla data di attivazione (stato APERTA) la domanda torna
 * compilabile normalmente.
 */
export function isInquiryReadonlyPreview(
  inquiry: TipoDomandaDTO | null | undefined,
) {
  return (
    inquiry?.flBloccaCompilazioneInvio === true &&
    inquiry?.stato === EnumTipoDomandaDTOStato.PUBBLICATA
  );
}
